var React = require('react');

function StarGreen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.9834 23.5876L25.2148 22.2352L27.3924 29.04L19.9834 23.5876ZM32 14.8276L22.8352 14.8052L20.0255 6L17.1736 14.7913L8 14.76L15.409 20.2124L12.5571 29.0038L19.9834 23.5876L32 14.8276Z","fill":"#04DA8D"}));
}

StarGreen.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = StarGreen;

StarGreen.default = StarGreen;
